import React, {
    ReactElement, ReactNode, useState,
} from "react";
import { Card } from "react-bootstrap";
import { FiChevronDown, FiChevronRight } from "react-icons/fi";

export default function ExpandingSection({
    title, children, defaultExpanded, className, topRightButton, topRightClicked, classBackground,
}: {
    title: string;
    defaultExpanded?: boolean;
    children: ReactElement[] | ReactElement | false | undefined | ReactNode;
    classBackground?: string;
    className?: string;
    topRightButton?: ReactElement;
    topRightClicked?: () => void;

}): ReactElement {
    const [isExpanded, setExpanded] = useState(defaultExpanded);
    return (
        <Card className="mb-3">
            <Card.Title className={`p-2 ${classBackground} m-0 d-flex justify-content-between`}>
                <button
                    type="button"
                    onClick={() => setExpanded(current => !current)}
                    className="text-start btn btn-none w-100 p-0 m-0"
                >
                    {isExpanded ? <FiChevronRight /> : <FiChevronDown />}
                    {" "}
                    {title}
                </button>
                {topRightButton && (
                    <button
                        type="button"
                        onClick={topRightClicked}
                        className="btn btn-none p-0 m-0"
                    >
                        {topRightButton}
                    </button>
                )}

            </Card.Title>
            {isExpanded && (
                <Card.Body className={className}>{children}</Card.Body>
            )}
        </Card>
    );
}
ExpandingSection.defaultProps = {
    defaultExpanded: false,
    className: "",
    topRightButton: undefined,
    topRightClicked: undefined,
    classBackground: "bg-gray-300",
};
